export const ServicesBannerIndustriales = [
    {
        titleLine1: "SOMOS LA ALTERNATIVA MÁS EFICIENTE PARA REALIZAR SU PROYECTO",
        // titleLine2: "",
        highlight: "¡CONTÁCTENOS Y EVITE EL USO DE ANDAMIOS!",
        description: "Solo envíe un mensaje con la descripción del servicio que desea que realicemos para ofrecerle una cotización personalizada.",
        buttonText: "SERVICIO PERSONALIZADO",
        buttonLink: "/contacto",
        backgroundColor: "#1226AA"
    }
];


export const ServicesBannerIndustrialesEn = [
    {
        titleLine1: "WE ARE THE MOST EFFICIENT ALTERNATIVE TO EXECUTE YOUR",
        titleLine2: "PROJECT",
        highlight: "CONTACT US AND AVOID USING SCAFFOLDING!",
        description:
            "Simply send us a message with the description of the service you need, and we’ll provide you with a personalized quote.",
        buttonText: "PERSONALIZED SERVICE",
        buttonLink: "/contacto",
        backgroundColor: "#1226AA"
    }
];